import { Box, Link, List, ListItem } from '@mui/material';
import LightTooltip from '../components/LightTooltip';
import { grey } from '@mui/material/colors';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

export const AccessGroupsGridCell = ({ row }) => {
    const ags = (row?.agroups || []).toSorted((a, b) => a.name.localeCompare(b.name));
    let label = <>&mdash;</>;
    if (ags.length === 1) {
        label = <Link href={`/user/permissions/group/${ags[0].id}`} target="_blank">{ags[0].name}</Link>;
    } else if (ags.length > 1) {
        label = `${ags[0].name} (+${ags.length - 1})`;
    }
    const tooltip =
        ags.length <= 1
            ? null
            : ags.map((ag) => (
                  <ListItem key={ag.id} dense disablePadding sx={{ py: 0.25 }}>
                      <Link href={`/user/permissions/group/${ag.id}`} target="_blank">
                          {ag.name}
                      </Link>
                  </ListItem>
              ));
    if (tooltip) {
        return (
            <LightTooltip
                arrow
                title={<List dense>{tooltip}</List>}
            >
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
                    {label}
                    <TipsAndUpdatesIcon fontSize="small" sx={{ color: grey[100] }} />
                </Box>
            </LightTooltip>
        );
    } else {
        return <>{label}</>;
    }

};

export default AccessGroupsGridCell;
